
// package imports
import ProductConstants from 'constants/ProductConstants';
import utils from './utils';

const initialDefaults = (formRef, data) => {
    let requestData = data.data.bi_request
    let planOption = Number(requestData.PlanOption)
    let ppt = requestData.PR_PPT
    let secondaryLaName = requestData.SecondLifeAssuredName
    let secondaryLastName = requestData.SecondLifeAssuredLastName
    let secondaryLaGendar = requestData.SecondLifeAssuredGender
    let secondaryLaDOB = requestData.SecLaDOB
    let pt = requestData.PR_PT
    let pt_value = requestData.PT_VALUE
    let inputMode = requestData.INPUT_MODE
    let accrualOfSurvivalBenefits = requestData.AccrualOfSurvivalBenefit_1
    let accrualOfSurvivalBenefit_2 = requestData.AccrualOfSurvivalBenefit_2
    let accrualOfSurvivalBenefit_3 = requestData.AccrualOfSurvivalBenefit_3
    let asbStartYearOne = requestData.ASB_StartPolicyYear_1
    let asbEndYearOne = requestData.ASB_EndPolicyYear_1
    let asbStartYearTwo = requestData.ASB_StartPolicyYear_2
    let asbEndYearTwo = requestData.ASB_EndPolicyYear_2
    let asbStartYearThree = requestData.ASB_StartPolicyYear_3
    let asbEndYearThree = requestData.ASB_EndPolicyYear_3
    let WithdrawalPercentageOne = requestData.WithdrawalPercentage_1
    let WithdrawalPercentageTwo = requestData.WithdrawalPercentage_2
    let WithdrawalPercentageThree = requestData.WithdrawalPercentage_3
    let liAge = Number(requestData.LI_ENTRY_AGE)

    if (Number(liAge) < 21) {
        formRef.$("plan-option").set("disabled", true);
    } else {
        formRef.$("plan-option").set("disabled", false);
    }

    // !Plan Option
    switch (planOption) {
        case 1:
            formRef.$('plan-option').set('value', { label: 'Lifelong Income', id: 1 })
            formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: false })
            formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: false })
            formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: false })
            formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: false })
            break;
        case 2:

            formRef.$('plan-option').set('value', { label: 'Family Secure', id: 2 },)
            let Gender = secondaryLaGendar === "4" ? { label: 'Male', id: "4" } : { label: 'Female', id: "5" }
            formRef.$('second-life-assured-first-name').set('extra', { ...formRef.$('second-life-assured-first-name').extra, hide: true })
            formRef.$('second-life-assured-first-name').value = secondaryLaName;
            formRef.$('second-life-assured-last-name').set('extra', { ...formRef.$('second-life-assured-last-name').extra, hide: true })
            formRef.$('second-life-assured-last-name').value = secondaryLastName;
            formRef.$('second-life-assured-dob').set('extra', { ...formRef.$('second-life-assured-dob').extra, hide: true })
            formRef.$('second-life-assured-dob').value = secondaryLaDOB;
            formRef.$('second-life-assured-gender').set('extra', { ...formRef.$('second-life-assured-gender').extra, hide: true })
            formRef.$('second-life-assured-gender').value = Gender;
            break;
        default:
            break;
    }


    // !PPT
    let pptList = utils.pptListBasedOnPlanOption(planOption)
    formRef.$('premium-term').set('extra', { ...formRef.$('premium-term').extra, optionList: pptList })
    formRef.$('premium-term').set('value', { label: ppt, id: ppt })



    // !PT

    formRef.$('policy-term').set('value', { label: "Upte Age 100", id: pt })
    let ptList = [
        { label: 'Upte Age 100', id: 0 },
    ]
    formRef.$('policy-term').set('extra', { ...formRef.$('policy-term').extra, optionList: ptList })



    // !Payment frequency
    switch (Number(inputMode)) {
        case 1:
            formRef.$('payment-frequency').set('value', {
                id: '1',
                label: 'Annual'
            })
            break;
        case 2:
            formRef.$('payment-frequency').set('value', {
                id: '2',
                label: 'Semi-Annual'
            })
            break;
        case 3:
            formRef.$('payment-frequency').set('value', {
                id: '3',
                label: 'Quarterly'
            })
            break;
        case 4:
            formRef.$('payment-frequency').set('value', {
                id: '4',
                label: 'Monthly'
            })
            break;

        default:
            break;
    }

    // !Accrual Of Survival Benefits
    switch (Number(accrualOfSurvivalBenefits)) {
        case 7:
            formRef.$('accrual-of-survival-benefit').set('value', { label: 'No', id: "7" })
            break;
        case 6:
            formRef.$('accrual-of-survival-benefit').set('value', { label: 'Yes', id: "6" })
            break;
        default:
            break;
    }

    // formRef.$("accrual-of-survival-benefits").set("disabled", true);
    utils.handleAsbCondition(formRef, accrualOfSurvivalBenefits)
    // Initial value of ASB Start year 1

    let asbStartYearOneList = utils.fetchASBstartPolicyOne(planOption, pt_value, ppt, formRef.$("asb-start-age-(1st-opt-in)").extra.preDefinedOptList,liAge)
    formRef.$("asb-start-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(1st-opt-in)").extra,
        optionList: asbStartYearOneList,
    });


    let asbStartYearOneOpt = asbStartYearOneList.filter((item) => Number(asbStartYearOne) === item.id)
    if (asbStartYearOneOpt.length > 0) formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneOpt[0])

    // Initial value of ASB End year 1
    let asbEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-age-(1st-opt-in)").value.id, asbStartYearOneList, formRef.$("asb-end-age-(1st-opt-in)").extra.preDefinedOptList)
    formRef.$("asb-end-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(1st-opt-in)").extra,
        optionList: asbEndYearOneList,
    });
    let asbEndYearOneOpt = asbEndYearOneList.filter((item) => Number(asbEndYearOne) === Number(item.id))
    if (asbEndYearOneOpt.length > 0) formRef.$("asb-end-age-(1st-opt-in)").set("value", asbEndYearOneOpt[0])

    let asbWithDrawalParcentage1 = formRef.$("withdrawal-parcentage-1").extra.preDefinedOptList
    formRef.$("withdrawal-parcentage-1").set("extra", {
        ...formRef.$("withdrawal-parcentage-1").extra,
        optionList: asbWithDrawalParcentage1,
    });

    let withdrawalPercentage1 = asbWithDrawalParcentage1.filter((item) => Number(WithdrawalPercentageOne) === Number(item.id))
    if (withdrawalPercentage1.length > 0) formRef.$("withdrawal-parcentage-1").set("value", withdrawalPercentage1[0])

    switch (Number(accrualOfSurvivalBenefit_2)) {
        case 320:
            formRef.$("accrual-of-survival-benefits-year-2").set("value", {
                id: accrualOfSurvivalBenefit_2,
                label: 'Yes',
            });
            break;

        case 321:
            formRef.$("accrual-of-survival-benefits-year-2").set("value", {
                id: accrualOfSurvivalBenefit_2,
                label: 'No',
            });
            break;

        default:
            break;
    }
    utils.handleAsbTwoCondition(formRef, accrualOfSurvivalBenefit_2)

    // Initial value of ASB Start year 2
    let asbTwoStartYearOneList = utils.fetchASBendPolicyOne(
        formRef.$("asb-end-age-(1st-opt-in)").value.id + 2,
        formRef.$("asb-end-age-(1st-opt-in)").extra.optionList,
        formRef.$("asb-start-age-(2nd-opt-in)").extra.preDefinedOptList
    );
    formRef.$("asb-start-age-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(2nd-opt-in)").extra,
        optionList: asbTwoStartYearOneList,
    });
    let asbTwoStartYearOneOpt = asbTwoStartYearOneList.filter((item) => Number(asbStartYearTwo) === item.id)
    if (asbTwoStartYearOneOpt.length > 0) formRef.$("asb-start-age-(2nd-opt-in)").set("value", asbTwoStartYearOneOpt[0])

    // Initial value of ASB End year 2
    let asbTwoEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-age-(2nd-opt-in)").value.id, asbTwoStartYearOneList, formRef.$("asb-end-age-(2nd-opt-in)").extra.preDefinedOptList)
    formRef.$("asb-end-age-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(2nd-opt-in)").extra,
        optionList: asbTwoEndYearOneList,
    });
    let asbTwoEndYearOneOpt = asbTwoEndYearOneList.filter((item) => Number(asbEndYearTwo) === item.id)
    if (asbTwoEndYearOneOpt.length > 0) formRef.$("asb-end-age-(2nd-opt-in)").set("value", asbTwoEndYearOneOpt[0])

    let asbWithDrawalParcentage2 = formRef.$("withdrawal-parcentage-2").extra.preDefinedOptList
    formRef.$("withdrawal-parcentage-2").set("extra", {
        ...formRef.$("withdrawal-parcentage-2").extra,
        optionList: asbWithDrawalParcentage2,
    });

    let withdrawalPercentage2 = asbWithDrawalParcentage2.filter((item) => Number(WithdrawalPercentageTwo) === Number(item.id))
    if (withdrawalPercentage2.length > 0) formRef.$("withdrawal-parcentage-2").set("value", withdrawalPercentage2[0])




    // Initial value of accrual of survival benefits 3
    switch (Number(accrualOfSurvivalBenefit_3)) {
        case 625:
            formRef.$("accrual-of-survival-benefits-year-3").set("value", {
                id: accrualOfSurvivalBenefit_3,
                label: 'Yes',
            });
            break;

        case 626:
            formRef.$("accrual-of-survival-benefits-year-3").set("value", {
                id: accrualOfSurvivalBenefit_3,
                label: 'No',
            });
            break;

        default:
            break;
    }
    utils.handleAsbThreeCondition(formRef, accrualOfSurvivalBenefit_3)

    // Initial value of ASB Start year 2
    let asbThreeStartYearOneList =utils.fetchASBendPolicyOne(
        formRef.$("asb-end-age-(2nd-opt-in)").value.id + 2,
        formRef.$("asb-end-age-(2nd-opt-in)").extra.optionList,
        formRef.$("asb-start-age-(3rd-opt-in)").extra.preDefinedOptList,
        liAge
    );
    formRef.$("asb-start-age-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(3rd-opt-in)").extra,
        optionList: asbThreeStartYearOneList,
    });
    let asbThreeStartYearOneOpt = asbThreeStartYearOneList.filter((item) => Number(asbStartYearThree) === item.id)
    if (asbThreeStartYearOneOpt.length > 0) formRef.$("asb-start-age-(3rd-opt-in)").set("value", asbThreeStartYearOneOpt[0])

    // Initial value of ASB End year 2
    let asbThreeEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-age-(3rd-opt-in)").value.id, asbThreeStartYearOneList, formRef.$("asb-end-age-(3rd-opt-in)").extra.preDefinedOptList)
    formRef.$("asb-end-age-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(3rd-opt-in)").extra,
        optionList: asbThreeEndYearOneList,
    });
    
    let asbThreeEndYearOneOpt = asbThreeEndYearOneList.filter((item) => Number(asbEndYearThree) === item.id)
    if (asbThreeEndYearOneOpt.length > 0) formRef.$("asb-end-age-(3rd-opt-in)").set("value", asbThreeEndYearOneOpt[0])

    let asbWithDrawalParcentage3 = formRef.$("withdrawal-parcentage-3").extra.preDefinedOptList
    formRef.$("withdrawal-parcentage-3").set("extra", {
        ...formRef.$("withdrawal-parcentage-3").extra,
        optionList: asbWithDrawalParcentage3,
    });

    let withdrawalPercentage3 = asbWithDrawalParcentage3.filter((item) => Number(WithdrawalPercentageThree) === Number(item.id))
    if (withdrawalPercentage3.length > 0) formRef.$("withdrawal-parcentage-3").set("value", withdrawalPercentage3[0])


    switch (data.productName) {

        case ProductConstants.LEGACY_PLUS_INCOME:
            formRef.$('accrual-of-survival-benefit').set('disabled', false)
            break;

        case ProductConstants.LEGACY_PLUS_LUMPSUM:
            formRef.$('accrual-of-survival-benefit').set('disabled', true)
            formRef.$('asb-start-age-(1st-opt-in)').set('disabled', true)
            formRef.$('asb-end-age-(1st-opt-in)').set('disabled', true )
            formRef.$('withdrawal-parcentage-1').set('disabled', true)
            
            formRef.$('accrual-of-survival-benefits-year-2').set('extra', { ...formRef.$('accrual-of-survival-benefits-year-2').extra, hide: true })
            formRef.$('asb-start-age-(2nd-opt-in)').set('extra', { ...formRef.$('asb-start-age-(2nd-opt-in)').extra, hide: true })
            formRef.$('asb-end-age-(2nd-opt-in)').set('extra', { ...formRef.$('asb-end-age-(2nd-opt-in)').extra, hide: true })
            formRef.$('withdrawal-parcentage-2').set('extra', { ...formRef.$('withdrawal-parcentage-2').extra, hide: true })
           
            formRef.$('accrual-of-survival-benefits-year-3').set('extra', { ...formRef.$('accrual-of-survival-benefits-year-3').extra, hide: true })
            formRef.$('asb-start-age-(3rd-opt-in)').set('extra', { ...formRef.$('asb-start-age-(3rd-opt-in)').extra, hide: true })
            formRef.$('asb-end-age-(3rd-opt-in)').set('extra', { ...formRef.$('asb-end-age-(3rd-opt-in)').extra, hide: true })
            formRef.$('withdrawal-parcentage-3').set('extra', { ...formRef.$('withdrawal-parcentage-3').extra, hide: true })

           
            break;



        default:
            break;
    }



    // !Riders
    if (requestData.ADBRider) {
        formRef.$('ADB').set('value', requestData.ADBRider !== '')
        if (requestData.ADBRider) {
            formRef.$('ADB-dropdown').set('value', requestData.ADBRider)
        }
    }
    if (requestData.ATPDRider) {
        formRef.$('ATPDRider').set('value', requestData.ATPDRider !== '')
        if (requestData.ATPDRider) {
            formRef.$('ATPDRider-dropdown').set('value', requestData.ATPDRider)
        }
    }
    if (requestData.WaiverOfPremiumRider) {
        formRef.$('WaiverOfPremiumRider').set('value', requestData.WaiverOfPremiumRider !== '')
    }

    if (requestData.IncomeBenefitRider) {
        formRef.$('IncomeBenefitRider').set('value', requestData.IncomeBenefitRider !== '')
        if (requestData.IncomeBenefitRider) {
            formRef.$('IncomeBenefitRider-dropdown').set('value', requestData.IncomeBenefitRider)
        }
    }
    if (requestData.CriticalIllnessRider) {
        formRef.$('CriticalIllnessRider').set('value', requestData.CriticalIllnessRider !== '')
        if (requestData.CriticalIllnessRider) {
            formRef.$('CriticalIllnessRider-dropdown').set('value', requestData.CriticalIllnessRider)
        }
    }
    if (requestData.PayorWaiverBenefitRider) {
                formRef.$('PayorWaiverBenefitRider').set('value', requestData.PayorWaiverBenefitRider !== '')
                if (formRef.$('PayorWaiverBenefitRider').value) {
            switch (requestData.PWB) {
                case '1':
                    formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
                        id: '1',
                        label: 'Option 1 (On Death)'
                    })
                    break;
                case '2':
                    formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
                        id: '2',
                        label: 'Option 2 (CI or ATPD)'
                    })
                    break;
                case '3':
                    formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
                        id: '3',
                        label: 'Option 3 (CI or ATPD or Death)'
                    })
                    break;
                default:
                    break;
            }
        }

        if (data.productName === ProductConstants.LEGACY_PLUS_INCOME
            || data.productName === ProductConstants.LEGACY_PLUS_LUMPSUM
        ) {
            formRef.$('ADB').set('extra', { ...formRef.$('ADB').extra, hide: false })
            formRef.$('PayorWaiverBenefitRider').set('extra', { ...formRef.$('PayorWaiverBenefitRider').extra, hide: false })
            formRef.$('ATPDRider').set('extra', { ...formRef.$('ATPDRider').extra, hide: false })
            formRef.$('CriticalIllnessRider').set('extra', { ...formRef.$('CriticalIllnessRider').extra, hide: false })
            formRef.$('IncomeBenefitRider').set('extra', { ...formRef.$('IncomeBenefitRider').extra, hide: false })
            formRef.$('WaiverOfPremiumRider').set('extra', { ...formRef.$('WaiverOfPremiumRider').extra, hide: false })
        }
    }

}

export default initialDefaults